export const required = (v) => !!v || 'Поле обязательно';
export const email = (v) => /.+@.+\..+/.test(v) || 'Email должен быть валидным';
export const min = (n) => (v) => v.length >= n || `Минимум ${n} символов`;
export const max = (n) => (v) => v.length <= n || `Максимум ${n} символов`;
export const same = (value) => (v) => v === value || 'Поля не совподают';
export const mustInteger = (v) => !Number.isNaN(Number(v)) || 'Необходимо ввести числовое значеие';
export const url = (v) => /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/.test(v) || 'Необходимо ввести корректную ссылку';

export default {
  required, email, min, max, same, mustInteger, url,
};
